import React, { Fragment } from 'react';

import { ShortcutsSection } from '@confluence/space-shortcuts/entry-points/shortcutsSection';
import { SpaceViewsController } from '@confluence/space-views';
import { PageTreeLoaderOnHover } from '@confluence/page-tree/entry-points/PageTreeLoader';
import { BlogTree } from '@confluence/blog-tree/entry-points/BlogTree';
import { expVal } from '@confluence/feature-experiments';

export const CommonSpaceNavigationContent = ({
	showShortcutsSection,
	space,
	spaceKey,
	quick,
	homepageId,
	loading,
	isSpaceAdmin,
	isBlogNavigation,
	blogsHidden,
	pageTreeFinishedLoading,
	onDragDropSuccess,
	onContentTreeLoadComplete,
}) => (
	<>
		{showShortcutsSection && (
			<ShortcutsSection
				isSpaceAdmin={isSpaceAdmin}
				spaceKey={spaceKey}
				links={quick}
				spaceId={space?.id || null}
			/>
		)}

		{!loading ? (
			<div
				data-vc="pageTree"
				data-testid="pageTree"
				onMouseEnter={
					expVal('confluence_frontend_remove_hydrateonhover_pagetree', 'isEnabled', true)
						? undefined
						: PageTreeLoaderOnHover.hydrateOnHover
				}
			>
				<SpaceViewsController
					key={spaceKey} // Remount on space change to reset Space views state
					homepageId={homepageId}
					onDragDropSuccess={onDragDropSuccess}
					isPeekingFromBlogs={isBlogNavigation}
					onContentTreeLoadComplete={onContentTreeLoadComplete}
					spaceHasUserContent={space?.didContainUserContent}
					pageTreeFinishedLoading={pageTreeFinishedLoading}
				/>
			</div>
		) : (
			<Fragment />
		)}

		{!loading && !blogsHidden && (
			<BlogTree spaceKey={spaceKey} pageTreeFinishedLoading={pageTreeFinishedLoading} />
		)}
	</>
);
